import { useTranslation } from 'react-i18next';
import SEOHead from '@/components/feature/SEOHead';
import Hero from './components/Hero';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryOverview from './components/CategoryOverview';
import FAQSection from './components/FAQSection';
import Testimonials from './components/Testimonials';
import NewsletterCTA from './components/NewsletterCTA';

export default function Home() {
  const { t } = useTranslation();

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '般若智慧',
    url: 'https://dharmaway.github.io',
    description: '以《心经》「色即是空」为核心的佛教哲学修行平台，提供般若智慧深度解读文章与修行指导。',
    email: 'contact@prajna-wisdom.org',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '杭州',
      addressRegion: '浙江',
      addressCountry: 'CN',
    },
    sameAs: [],
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '般若智慧',
    url: 'https://dharmaway.github.io',
    description: '色即是空——感悟般若智慧的修行落地页，深度解析心经智慧与佛教空性哲学。',
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '色即是空——感悟般若智慧的修行落地页',
    description: '「色即是空」出自《心经》核心偈语，揭示万物本质皆为空性的佛教哲学智慧。本页深度解析色即是空的真实含义、修行应用与现代生活启示。',
    url: 'https://dharmaway.github.io',
    isPartOf: {
      '@type': 'WebSite',
      name: '般若智慧',
      url: 'https://dharmaway.github.io',
    },
  };

  return (
    <>
      <SEOHead
        title="色即是空——感悟般若智慧的修行落地页 | 心经般若智慧解读"
        description="「色即是空」出自《心经》核心偈语，揭示万物本质皆为空性的佛教哲学智慧。深度解析色即是空的真实含义、修行应用与现代生活启示，帮助你放下执念、洞见本心，体悟空性之美。"
        keywords="色即是空,色即是空的含义,色即是空空即是色,心经般若智慧,佛教空性哲学,放下执念修行,般若波罗蜜多心经解读"
        canonicalUrl="https://dharmaway.github.io/"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />

      <main>
        <Hero />
        <FeaturedArticles />
        <CategoryOverview />
        <Testimonials />
        <FAQSection />
        <NewsletterCTA />
      </main>
    </>
  );
}